
export function iframepost(item,url,loadingUrl,vm,callback,type,data,jsonStr){
	//加密参数
	if(jsonStr){
        jsonStr=encodeURIComponent(jsonStr);
	}else {
        jsonStr = ''
	}

    type=type.toLowerCase();
    if(type == 'post'){
        data = JSON.stringify(data)
    };

    let post_url;

    if(process.env.NODE_ENV=="production"){
        //走正式请求

        document.domain = 'zt.cn';
        post_url=url;
    }else{
        //走调试
        document.domain = 'zt.cn';
        loadingUrl=loadingUrl.split('/api')[0];
        post_url=url.replace('http://test.zt.cn',loadingUrl);
        if(type=='get' && data!={}){
			post_url += (post_url.indexOf('?') < 0 ? '?' : '&') + param(data);
		}
    };
    return item.send(post_url,function(res){
    	var result=JSON.parse(res.responseText);
		if(result.hasOwnProperty('code')){

			if(result.code==101){
				vm.$confirm(result.msg, '提示', {
			        confirmButtonText: '确定',
			        cancelButtonText: '取消',
			        type: 'warning'
		        }).then(() => {
			       	//location.href='/loginp.html?redirectUrl='+jsonStr;//正式
		            location.href='/loginp.html#/redirectUrl='+encodeURIComponent(jsonStr);
		        }).catch(() => {
					console.log('已取消');
				});
        	}else if(result.code==102){
        		vm.$confirm(result.msg, '提示', {
			        confirmButtonText: '确定',
			        cancelButtonText: '取消',
			        type: 'warning'
		        }).then(() => {
					//location.href='/loginp.html?redirectUrl='+jsonStr;//正式
					//location.href='/loginp.html#/redirectUrl='+encodeURIComponent(jsonStr);
					console.log('添加后台链接');
		        }).catch(() => {
					console.log('已取消');
				});
        	}else if(result.code==103){
        		vm.$confirm(result.msg, '提示', {
			        confirmButtonText: '确定',
			        cancelButtonText: '取消',
			        type: 'warning'
		        }).then(() => {
			       	//location.href='/loginp.html?redirectUrl='+jsonStr;//正式
		            location.href='/loginp.html#/redirectUrl='+encodeURIComponent(jsonStr);
		        }).catch(() => {
					console.log('已取消');
				});
        	}else if(result.code==104){
        		vm.$confirm(result.msg, '提示', {
			        confirmButtonText: '确定',
			        cancelButtonText: '取消',
			        type: 'warning'
		        }).then(() => {
					//location.href='/loginp.html?redirectUrl='+jsonStr;//正式
		            location.href='/loginp.html#/redirectUrl='+encodeURIComponent(jsonStr);
		        }).catch(() => {
					console.log('已取消');
				});
        	}else{
				callback(result);
			}
		}else{
            	callback(result);
		};
    },type,data);
  	// 拼接参数
	function param(data) {
	  let url = ''
	  for (var k in data) {
	    let value = data[k] !== undefined ? data[k] : ''
	    if (typeof value == 'object') {
	      value = JSON.stringify(value)
	    }
	    url += '&' + k + '=' + encodeURIComponent(value)
	  }
	
	  return url ? url.substring(1) : ''
	}  
};

// import axios from 'axios'
// import md5 from 'js-md5'
// import stringify from 'json-stringify-safe'
// import parse from 'parse-json'

//     if(process.env.NODE_ENV=="production"){
//         //走正式请求
//         document.domain = 'sitezt.cn';
//     }else{
//         //走调试
//     }